(async () => {
  const { 
    loadScript,
    loadStyle
  } = await import(window.theme.modules.utils);

  const baseComponent = await import(window.theme.modules.baseComponent);

  const isChromeForIOs145 = () => {
    const userAgent = window.navigator.userAgent;
    const isChromeForIOs = /CriOS/i.test(userAgent);
    if (isChromeForIOs) {
      const iOsMatch = userAgent.match(
        /(.+)(iPhone|iPad|iPod)(.+)OS[\s|\_](\d+)\_?(\d+)?[\_]?(\d+)?.+/i
      );
      if (iOsMatch && iOsMatch.length >= 6) {
        const iOsVersionMajor = parseInt(iOsMatch[4], 10);
        const iOsVersionMinor = parseInt(iOsMatch[5], 10);
        if (iOsVersionMajor >= 14 && iOsVersionMinor >= 6) {
          return true;
        }
      }
    }
    return false;
  }

  customElements.define('slide-show-custom-mobile', class extends baseComponent.default {
    elements = {
      sliderContainer: '[data-slider-container]',
      nextButton: '[data-slider-button-next]',
      prevButton: '[data-slider-button-prev]',
      pagination: '[data-slider-pagination]'
    }


    async render() {
      await this._initSwiper();
      var sectionId = this.getAttribute('data-section-id');
      var dotsElement = document.querySelector(".dots_wrapper--" + sectionId + ' .dots_wrapper');
      if (window.innerWidth < 992) {
        if(dotsElement) {       
          var swiperDots = new window.Swiper(dotsElement, {
            spaceBetween: 8,
            slidesPerView: 4,
            freeMode: false,
            watchSlidesProgress: true,
            allowTouchMove: false,
            navigation: {
              nextEl: ".dots_wrapper--" + sectionId + " .swiper-button-next",
              prevEl: ".dots_wrapper--" + sectionId + " .swiper-button-prev"
            },  
          });
        }
        
        var swiperParams = {
          pagination: false,
          navigation: {
            nextEl: this.$nextButton,
            prevEl: this.$prevButton
          },
          thumbs: {
          swiper: swiperDots,
          },
          zoom: this.hasAttribute('zoom'),
          breakpoints: this.hasAttribute('desktop-no-swipe') && {
            992: {
              allowTouchMove: false
            }
          },
          cssMode: isChromeForIOs145()
        }
  
        if (this.hasAttribute('sync-slider')) {
          this.syncSlider = document.getElementById(this.getAttribute('sync-slider'));
          swiperParams.initialSlide = this.syncSlider.getCurrentSlide();
        }
  
        this.swiper = new window.Swiper(this.$sliderContainer, swiperParams);
        var mainSwiper = this.swiper;
          
      if(dotsElement){
         swiperDots.on('slideChange', function () {
          var activeIndex = this.activeIndex; 
        console.log(mainSwiper);
        mainSwiper.slideTo(activeIndex);
       // mainSwiper.thumbs.update();  
        });
      }
  
        if (this.syncSlider) {
          this.swiper.on('slideChange', () => {
            this.syncSlider.slideTo(this.getCurrentSlide());
          })
        }
  
        if (this.hasAttribute('initial-slide')) {
          this.slideTo(+this.getAttribute('initial-slide'))
        }
      }
    };

    async _initSwiper() {
      await loadScript(window.theme.scripts.Swiper, 'swiper');
      loadStyle(window.theme.styles.Swiper);
    };

    getCurrentSlide() {
      return this.swiper.activeIndex;
    }

    slideTo(index) {
      this.swiper.slideTo(index);
    }

  });
})();